import {observable, action, runInAction} from 'mobx'
import alertMessage from '../utils/alertMessage'
import intelligentQueryAPI from '../apis/intelligentQueryAPI'

export default class IntelligentQueryStore {
  @observable isFetching = false
  @observable pageNo = 1
  @observable pageSize = 10
  @observable itemCount = 0

  @observable terminologyList = []
  @observable terminologyDetailsObj = null
  @observable terminologySearchItem = {
    word: ''
  }

  @observable sqlExampleList = []
  @observable sqlExampleDetailsObj = null
  @observable sqlExampleSearchItem = {
    question: ''
  }

  @observable dataSourceList = []
  @observable advancedApplicationList = []

  @action
  async onTerminologySearchAction(params) {
    this.isFetching = true
    this.terminologyList = []
    this.pageNo = params.page
    this.pageSize = params.size
    this.itemCount = 0
    try {
      const response = await intelligentQueryAPI.terminologySearchAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.terminologyList = response.data.data?.data || []
          this.itemCount = response.data.data?.total_count
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async onTerminologyAddAction(params, title) {
    this.isFetching = true
    try {
      const response = await intelligentQueryAPI.terminologyAddAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success(title === 'edit' ? '修改成功！' : '添加成功！')
          this.onTerminologySearchAction({
            ...this.terminologySearchItem,
            'page': this.pageNo,
            'size': this.pageSize,
          })
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async onTerminologyDeleteAction(id) {
    this.isFetching = true
    try {
      const response = await intelligentQueryAPI.terminologyDeleteAction(id)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('删除成功！')
          this.onTerminologySearchAction({
            ...this.terminologySearchItem,
            'page': this.pageNo,
            'size': this.pageSize,
          })
        } else {
          alertMessage.error(response.data.msg)
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async onTerminologyStatusAction(params) {
    try {
      const response = await intelligentQueryAPI.terminologyStatusAction(params)
      runInAction(() => {
        if (response.data.code === 0) {
          alertMessage.success(params.enabled ? '启用成功！' : '禁用成功！')
          this.onTerminologySearchAction({
            ...this.terminologySearchItem,
            'page': this.pageNo,
            'size': this.pageSize,
          })
        } else {
          alertMessage.error(response.data.msg)
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
    }
  }

  @action
  onTerminologyPageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNo = pageNo
      this.pageSize = pageSize
    })
    this.onTerminologySearchAction({
      ...this.terminologySearchItem,
      'page': pageNo,
      'size': pageSize,
    })
  }

  @action
  async onSqlExampleSearchAction(params) {
    this.isFetching = true
    this.sqlExampleList = []
    this.pageNo = params.page
    this.pageSize = params.size
    this.itemCount = 0
    try {
      const response = await intelligentQueryAPI.sqlExampleSearchAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.sqlExampleList = response.data.data?.data || []
          this.itemCount = response.data.data?.total_count
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async onSqlExampleAddAction(params, title) {
    this.isFetching = true
    try {
      const response = await intelligentQueryAPI.sqlExampleAddAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success(title === 'edit' ? '修改成功！' : '添加成功！')
          this.onSqlExampleSearchAction({
            ...this.sqlExampleSearchItem,
            'page': this.pageNo,
            'size': this.pageSize,
          })
        } else {
          alertMessage.error(response.data.msg)
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async onSqlExampleDeleteAction(id) {
    this.isFetching = true
    try {
      const response = await intelligentQueryAPI.sqlExampleDeleteAction(id)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('删除成功！')
          this.onSqlExampleSearchAction({
            ...this.sqlExampleSearchItem,
            'page': this.pageNo,
            'size': this.pageSize,
          })
        } else {
          alertMessage.error(response.data.msg)
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async onSqlExampleStatusAction(params) {
    this.isFetching = true
    try {
      const response = await intelligentQueryAPI.sqlExampleStatusAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success(params.enabled ? '启用成功！' : '禁用成功！')
          this.onSqlExampleSearchAction({
            ...this.sqlExampleSearchItem,
            'page': this.pageNo,
            'size': this.pageSize,
          })
        } else {
          alertMessage.error(response.data.msg)
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  onSqlExamplePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNo = pageNo
      this.pageSize = pageSize
    })
    this.onSqlExampleSearchAction({
      ...this.sqlExampleSearchItem,
      'page': pageNo,
      'size': pageSize,
    })
  }

  @action
  async onGetAdvancedApplicationList() {
    this.advancedApplicationList = []
    try {
      const response = await intelligentQueryAPI.getAdvancedApplicationList()
      runInAction(() => {
        if (response.data.code === 0) {
          this.advancedApplicationList = response.data.data || []
        }
      })
    } catch (err) {        
      alertMessage.error('获取高级应用列表异常！' + err.message)
    }
  }
}